@import 'bootswatch/dist/flatly/variables';
@import 'bootstrap/scss/bootstrap';
@import 'bootswatch/dist/flatly/bootswatch';

body {
  font-size: 0.9em;
}

.navbar-brand {
  background: url('/esrf-white.png') no-repeat;
  background-size: contain;
  padding-left: 60px;
}

.navbar-brand:hover {
  color: var(--bs-navbar-brand-hover-color) !important;
}
